<template>
  <transition name="slide-fade">
    <app-loader v-if="loading"></app-loader>
    <div class="page" v-else>
      <div class="elm pa-0">
        <app-header auth></app-header>
      </div>
      <div class="elm container breadcrumb pb-4 pt-10">
        <v-row no-gutters align="center">
          <v-col>
            <h3>Lista Polizze</h3>
          </v-col>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  fab
                  depressed
                  dark
                  small
                  color="primary"
                  :to="{ name: 'RequestAdd' }"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon dark>
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>Invia richiesta</span>
          </v-tooltip>
        </v-row>
      </div>
      <div class="container elm bra fill mb-10">
        <v-row no-gutters align="start">
          <v-data-table
              :headers="headers"
              :items="items"
              item-key="name"
              class="pa-6"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn icon>
                <v-icon
                    small
                    class="mr-2 ml-2"
                >
                  mdi-email {{item}}
                </v-icon>
              </v-btn>
              <v-icon
                  small
                  class="mr-2 ml-2"
              >
                mdi-pencil {{item}}
              </v-icon>
              <v-icon
                  small
                  class="mr-2 ml-2"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-row>
      </div>
      <app-footer class="box"></app-footer>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
th{
  font-size: 1rem;
  font-weight: 500;
}
</style>

<script>
//import { db } from "../main";
import AppHeader from '../../components/header'
import AppFooter from '../../components/footer'
import AppLoader from "../../components/loader";
// @ is an alias to /src
export default {
  name: 'home',
  components: {AppLoader, AppHeader,AppFooter},
  mounted () {

    this.loading = false
    // Binding Collections
    /*this.$binding("parent", db.collection("categories").orderBy("title")).then(async (res) => {
        await res.forEach(elm => {
            elm['products'] = []
            db.collection("categories").doc(elm.id).collection("products").orderBy("title").get().then(async (nest) => {
                await nest.forEach(e => {
                    elm['products'].push(e.data())
                })
                this.categories.push(elm)
                if(this.categories.length >= 6) {
                    this.loading = false
                }
            })
        })
    })*/
  },
  data: () => ({
    headers: [
      { text: 'Nome', value: 'actions', sortable: false },
      { text: 'Creato il', align: 'start', sortable: false, value: 'calories'},
      { text: 'Aggiornato il', align: 'start', sortable: false, value: 'calories'},
    ],
    loading: true,
    items: [],
  }),
}
</script>
